<!-- Button -->
<button *ngIf="isVisible()" mat-icon-button (click)="abrirDocumentacion()">
    <span class="relative">
        <mat-icon
            [svgIcon]="'heroicons_solid:help'"
        ></mat-icon>
    </span>
</button>